import * as React from "react";
import { DatePicker } from "../../../../../../../react-core/Datepicker/DatePicker";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { addDays } from "../../../../../../../react-core/utils/date";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { ContentDatePicker } from "../../../../../../Shared/Entities/Constants/DateConstants";

import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import {
    MoneyPurchaseAnnualAllowanceSourceArray,
    MoneyPurchaseAnnualAllowanceSourceArrayMap,
} from "../../../NewBusinessWizard/Resource/Contents";
import { PensionContribution } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContribution";
import { datePickerOptions, MpaaQuestionText } from "../../Resource/Contents";

interface IMoneyPruchaseAnnualAllowanceProps extends IProcessComponentProps {
    data: PensionContribution;
}

interface IMoneyPurchaseAnnualAllowanceState {}

export class MoneyPurchaseAnnualAllowanceComponent extends ProcessComponent<
    IMoneyPruchaseAnnualAllowanceProps,
    IMoneyPurchaseAnnualAllowanceState
> {
    constructor(props: any) {
        super(props);
        this.state = {};
        delete datePickerOptions.todayButton;
    }

    componentDidMount() {
        super.componentDidMount();
        const { data, onChange } = this.props;
        if (data?.MoneyPurchaseAnnualAllowance?.Triggered != null && !data?.MoneyPurchaseAnnualAllowance?.Triggered) {
            this.onDataChange(
                onChange,
                {
                    Triggered: data?.MoneyPurchaseAnnualAllowance?.Triggered,
                },
                data,
                "MoneyPurchaseAnnualAllowance"
            );
        }
    }

    private renderMoneyPruchaseAnnualAllowance(data: PensionContribution, onChange) {
        return (
            <>
                <div className="row">
                    <div className="col-auto">
                        <RadiosEditor
                            cssWrapper="radio-group rg-inline rg-150 mb-23"
                            selected={
                                data?.MoneyPurchaseAnnualAllowance?.Triggered == null
                                    ? false
                                    : data?.MoneyPurchaseAnnualAllowance?.Triggered
                            }
                            options={[true, false, null]}
                            label={MpaaQuestionText}
                            getText={(v) => {
                                return v == null ? "Not known" : v ? "Yes" : "No";
                            }}
                            onChange={(v) =>
                                this.onDataChange(
                                    onChange,
                                    {
                                        Triggered: v,
                                        DateTriggered: null,
                                        Source: null,
                                    },
                                    data,
                                    "MoneyPurchaseAnnualAllowance"
                                )
                            }
                        />
                    </div>
                </div>
                {data?.MoneyPurchaseAnnualAllowance?.Triggered && (
                    <>
                        <div className="row">
                            <div className="col-sm-4 col-12">
                                <DatePicker
                                    label="Effective date"
                                    atMost={{
                                        value: addDays(new Date(), -1),
                                        errorMessage: ContentDatePicker.CannotBeInTheFuture,
                                    }}
                                    atLeast={{
                                        value: new Date(2015, 3, 6),
                                        errorMessage: "Date cannot be earlier than 6 April 2015",
                                    }}
                                    selected={JsonDateParser.toDateNoOffset(
                                        data?.MoneyPurchaseAnnualAllowance?.DateTriggered
                                    )}
                                    onChange={(v) =>
                                        this.onDataChange(
                                            onChange,
                                            { DateTriggered: JsonDateParser.toJsonDateNoOffset(v) },
                                            data,
                                            "MoneyPurchaseAnnualAllowance"
                                        )
                                    }
                                    alwaysValidateOnUpdate={false}
                                    {...datePickerOptions}
                                    required="Please select Effective date"
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6 col-12">
                                <SelectEditor
                                    options={MoneyPurchaseAnnualAllowanceSourceArray}
                                    getText={(v) => MoneyPurchaseAnnualAllowanceSourceArrayMap[v]}
                                    required="Please select Reason"
                                    placeholder="Please select"
                                    selected={data?.MoneyPurchaseAnnualAllowance?.Source}
                                    label="Reason why"
                                    onChange={(v) =>
                                        this.onDataChange(onChange, { Source: v }, data, "MoneyPurchaseAnnualAllowance")
                                    }
                                />
                            </div>
                        </div>
                    </>
                )}
            </>
        );
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        return (
            <>
                {/* {SectionHeader("Money Purchase Annual Allowance")} */}
                {this.renderMoneyPruchaseAnnualAllowance(data, onChange)}
            </>
        );
    }
}
